import { render, staticRenderFns } from "./HoldingNoUpdate old.vue?vue&type=template&id=8aaf5c72&scoped=true&"
import script from "./HoldingNoUpdate old.vue?vue&type=script&lang=js&"
export * from "./HoldingNoUpdate old.vue?vue&type=script&lang=js&"
import style0 from "./HoldingNoUpdate old.vue?vue&type=style&index=0&id=8aaf5c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaf5c72",
  null
  
)

export default component.exports